<template>
  <v-card width="600">
    <apexchart type="donut" width="100%" :options="chartOptions" :series="series"></apexchart>
  </v-card>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  name: "PieChart",
  props: ['labels', 'values', 'selected'],
  components: {
    apexchart: VueApexCharts,
  },
  computed:  {
    chartOptions: function() {
      return {
        chart: {
          type: 'donut',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              this.$emit('update:selected', this.labels[config['dataPointIndex']])
            }
          },
        },
        legend: {
          position: 'bottom',
          show: true,
        },
        colors: ["#7400b8", "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50",
          "#8bc34a", "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff5722", "#795548", "#9e9e9e",
          "#607d8b", "#000000", "#e81e63", "#f44336", "#9c27b0"
        ],
        dataLabels: {
          formatter: function (val, opts) {
            return opts.w.config.series[opts.seriesIndex]
          },
        },
        responsive: [{
          breakpoint: 500,
          options: {
            chart: {
              width: '100%'
            },
            legend: {
              show: true,
            },
          },
        }],
        noData: {
          text: 'Descargando...'
        }
      }
    }
  },
  created() {
    this.series = this.values;
    this.chartOptions.labels = this.labels;
  },

}
</script>

<style scoped>
</style>
